<template>
    <div class="container">
        <div class="content">
            <data-title :list="platformAccountData"></data-title>
            <div class="forms">
                <el-form :inline="true" :model="form" ref="form" class="search-form" size="small" label-width="64px">
                    <el-form-item label="所属平台">
                        <template #label>
                            <div class="custom-label">所属平台</div>
                        </template>
                        <el-select v-model="form.platformKey" placeholder="请选择" filterable clearable>
                            <el-option v-for="(item,index) in shops" :key="index" :label="item"
                                :value="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="最后归属人">
                        <template #label>
                            <div class="custom-label">最后<br />归属人</div>
                        </template>
                        <el-autocomplete class="inline-input" v-model="form.ownerUserName" :fetch-suggestions="userSearch" placeholder="请输入内容" :trigger-on-focus="false" @select="userSelect"
                            clearable></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="最后归属部门">
                        <template #label>
                            <div class="custom-label">最后<br />归属部门</div>
                        </template>
                        <el-cascader @change="handleSelectOrgId" v-model="form.orgId1"
                            :options="options" :show-all-levels="false" :props="{
                           checkStrictly: true,
                            label: 'orgName',
                            value: 'orgPath',
                            children: 'children',}" clearable filterable>
                        </el-cascader>
                    </el-form-item>
                        <el-form-item label="使用状态">
                        <template #label>
                            <div class="custom-label">使用状态</div>
                        </template>
                        <el-select v-model="form.usingStatus" placeholder="请选择" clearable>
                            <el-option v-for="item in dictionaries.property_paccount_ustatus" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <eldate @changeData="changeData($event)" :dateData="createdTime"></eldate>
                    </el-form-item>
                    <el-form-item label="资料缺失情况">
                        <template #label>
                            <div class="custom-label">资料<br />缺失情况</div>
                        </template>
                        <el-select v-model="form.lostId" placeholder="请选择" clearable>
                            <el-option v-for="item in dictionaries.property_platform_account_lost" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="注册形式">
                        <template #label>
                            <div class="custom-label">注册形式</div>
                        </template>
                        <el-select v-model="form.regType" placeholder="请选择" clearable>
                            <el-option v-for="item in dictionaries.property_paccount_reg_type" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="归属人是否离职">
                        <template #label>
                            <div class="custom-label">归属人<br />是否离职</div>
                        </template>
                        <el-select v-model="form.ownerUserStatus" placeholder="请选择" clearable>
                            <el-option v-for="item in dictionaries.employee_status" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="平台账号状态">
                        <template #label>
                            <div class="custom-label">平台账号<br />状态</div>
                        </template>
                        <el-select v-if="dictionaries.property_phone_status" v-model="form.status" placeholder="请选择" clearable>
                            <el-option v-for="item in dictionaries.property_phone_status" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审批状态">
                        <el-select v-if="dictionaries.property_act_status" v-model="form.actStatus" placeholder="请选择" clearable>
                            <el-option v-for="item in dictionaries.property_act_status" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <div style="display: flex;">
                            <div class="s-btn" @click="fetchData('search')">查询</div>
                            <div class="r-btn" @click="fetchData('reset')">重置</div>
                        </div>
                    </el-form-item>
                </el-form>
                <div class="line"></div>
                <div class="data-title">
                    <div style="display: flex;height: 32px;">
                        <div class="title-line"></div>
                        <div class="title-name">数据列表</div>
                    </div>

                    <div class="title-btn">
                        <div class="title-btn-item" style="margin-right: 12px;" @click="deliverData()" v-if="parArray.includes('platform_export')">
                            <img src="@/assets/img/assetManagement/icon_daochu.png" style="width: 16px;height: 16px;" />
                            <div class="btn-l">导出列表</div>
                        </div>
                        <div class="title-btn-item" style="margin-right: 12px;" @click="transferData()" v-if="parArray.includes('platform_transfer')">
                            <img src="@/assets/img/assetManagement/icon_dayin.png" style="width: 16px;height: 16px;" />
                            <div class="btn-l">批量转移</div>
                        </div>
                        <div class="title-btn-item" @click="add">
                            <i class="el-icon-plus"></i>
                            <div class="btn-l">新增平台账号</div>
                        </div>
                    </div>
                </div>
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10,20,30,50,200,2000]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange" v-loading="loading">
                </lb-table>
            </div>
        </div>
        <org-picker title="转移" :multiple="false" ref="orgPicker" @ok="selected" />
        <pop-report ref="popReport" :btnTransfer="btnTransfer" :reportList="reportList" />
        <pop-cancel ref="popCancel" title="是否确认注销该平台账号？" @setCancel="setCancel" />
        <pop-revoke ref="popRevoke" title="是否确认撤销该平台账号？" @setRevoke="setRevoke" />
        <pop-delete ref="popDelete" title="是否确认删除？" @setDelete="setDelete" />
        <pop-Remark ref="popRemark" @setRemark="setRemark" />
    </div>
</template>
<script>
import dataTitle from "@/pages/assetManagement/common/dataTitle.vue";
import eldate from "@/components/eldate.vue";
import LbTable from "@/components/lb-table/lb-table";
import platformAccountMixins from '@/pages/assetManagement/common/mixins/platformAccount'
export default {
    name: "platformAccount",
    mixins: [platformAccountMixins],
    components: { dataTitle, eldate, LbTable },
    data() {
        return {
            form: {
                platformKey: '',
                ownerUserName: '',
                orgId1:[],
                ownerOrgPath: '',
                usingStatus: '',
                regType: '',
                ownerUserStatus: '',
                status: '',
                actStatus: '',
                lostId:'',
                officeStatus:'',
                createdTimeStart: '',
                createdTimeEnd: '',
                updatedTimeStart: '',
                updatedTimeEnd: '',
            },
            page: {
                pageNo: 1,
                pageSize: 10
            },
            shops:[],
            loading: false,
            btnTransfer: false,
            list: [],
            options: [],
            platformAccountData: [],
            reportList:[],
            parArray: [],
            totalNum: 0,
            createdTime: [],
            updatedTime: [],
            dictionariesList: [],//数据字典
            dictionaries: { // 字典数据
                property_act_status: [], // 审批状态
                property_phone_status: [], // 状态
                // property_paccount_platform: [], // 所属平台
                property_paccount_reg_type: [], // 注册形式
                property_paccount_ustatus: [], // 使用状态
                property_platform_account_lost: [], // 资料缺失情况
                employee_status: [], // 员工状态
            },
            columns: [
                { type: 'selection', width: '80' },
                { label: '账号名称', prop: 'accountName', width: '100',
                     render:( h,scope) => {
                        return (
                            <div class='ellipsis' title={scope.row.accountName}>{scope.row.accountName}</div>
                        )
                    }
                },
                { label: '平台账号', prop: 'account', minWidth: '180',
                render: (h, scope) => {
                        const { accountList,accountFlagList, status, statusLabel } = scope.row;
                        return (
                            <div class='align-left'>
                                {accountList?.map((account,index) => (
                                     <span class='account-con'><span class='account'>{account}</span><span class='icon'>{ accountFlagList[index]=='1' ? '主' : '子' }</span></span>
                                ))}
                                {<span class={`icon-status icon-status-${status}`}>{statusLabel}</span>}
                            </div>
                        )
                    }
                },
                { label: '所属平台', prop: 'platformName', width: '88',
                    // render: (h, scope) => {
                    //     const operatorId = scope.row.platformKey;
                    //     // if (!operatorId) return "-";
                    //     // const dictItem = this.dictionaries.property_paccount_platform.find(item => item.dictId == operatorId).dictName;
                    //     return (
                    //         <div>{platformName ? platformName : "-"}</div>
                    //     )
                    // }
                 },
                { label: '创建时间', prop: 'createdTime', sortable: true, minWidth: '160' },
                {
                    label: '最后归属人', prop: 'ownerUserName', minWidth: '140',
                    render: (h, scope) => {

                        return (
                            <div  class='align-left'>{scope.row.ownerUserName ? scope.row.ownerUserName : "-"}</div>
                        )
                    }
                },
                {
                    label: '注册形式', prop: 'regType', width: '120',
                    render: (h, scope) => {
                        const regTypeId = scope.row.regType;
                        if (!regTypeId) return "-";
                        const dictItem = this.dictionaries.property_paccount_reg_type.find(item => item.dictId == regTypeId).dictName;
                        return (
                            <div class='align-left'>{dictItem ? dictItem : "-"}</div>
                        )
                    }
                },
                { label: '更新时间', prop: 'updatedTime', sortable: true,  width: '160' },
                { label: '审批状态', prop: 'actStatusLabel', minWidth: '120',
                    render: (h, scope) => {
                        const { actStatus, actStatusLabel } = scope.row;
                        return (
                            <div class='align-left'>
                                <span class={`icon-act-status icon-act-status-${actStatus}`}></span>{actStatusLabel}
                            </div>
                        )
                    }
                },
                 { label: '使用状态', prop: 'usingStatus', width: '100',
                  renderHeader: (h, scope) => {
                    return (
                      <div class='align-center'>使用状态</div>
                    );
                  },
                    render:( h,scope) => {
                        const usingStatus = scope.row.usingStatus;
                        if (!usingStatus) return "-";
                        const dictItem = this.dictionaries.property_paccount_ustatus.find(item => item.dictId == usingStatus).dictName;
                        return (
                            <div>{dictItem ? dictItem : "-"}</div>
                        )
                    }
                  },
                  { label: '资料缺失情况', prop: 'lostMessages', minWidth: '160',
                    render:( h,scope) => {
                        // const lostMessagesId = scope.row.lostMessages;
                        // if (!lostMessagesId || lostMessagesId == null) return "-";
                        // const dictItem = this.dictionaries.property_platform_account_lost.find(item => item.dictId == lostMessagesId).dictName;
                        return (
                            <div class='ellipsis2 red' title={scope.row.lostMessages}>{scope.row.lostMessages}</div>
                        )
                    }
                   },
                { label: '平台账号备注', prop: 'remarks', minWidth: '150',
                    render: (h, scope) => {

                        return (
                            <div class='ellipsis2' title={scope.row.remarks}>{scope.row.remarks ? scope.row.remarks : "-"}</div>
                        )
                    }
                 },
                 {
                    label: '操作', prop: 'orgName', width: '150', fixed: 'right',
                    render: (h, scope) => {
                        let permission = scope.row.permission
                        let vv = ''
                        vv = (<div style="display:flex;">
                            <div class={permission.check ? '' : 'hidden'} style="color:#00B498;cursor:pointer;margin-right:8px" onClick={() => { this.lookDetail(scope.row, scope.$index) }} >查看/编辑</div>
                            <div class={scope.row.hasMore ? '' : 'hidden'} >
                                <el-dropdown onCommand={($event) => { this.command($event, scope.row) }}>
                                    <span class="el-dropdown-link" style="color:#00B498;cursor:pointer">
                                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="transfer" class={permission.transfer ? '' : 'hidden'}>转移</el-dropdown-item>
                                        <el-dropdown-item command="cancel"  class={permission.cancel ? '' : 'hidden'}>注销</el-dropdown-item>
                                        <el-dropdown-item command="revoke"  class={permission.revoke ? '' : 'hidden'}>撤销</el-dropdown-item>
                                        <el-dropdown-item command="remark"  class={permission.note ? '' : 'hidden'}>备注</el-dropdown-item>
                                        <el-dropdown-item command="delete"  class={permission.delete ? '' : 'hidden'}>删除</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div >)
                        return vv
                    }
                },
            ]
        }
    },
     activated() {
        this.fetchData();
    },
    created() {
        this.department()
        this.getShop();
        // 获取字典值
        for (const type in this.dictionaries) {
            this.getDictionaries(type)
        }
        const limits = JSON.parse(sessionStorage.getItem("limit"))
        const params = limits.buttonTreeDto.find(
            (item) => item.menuCode === "platformAccount"
        )
        params.buttonList.forEach((item) => {
            this.parArray.push(item.code)
        })

    },
    methods: {
        // 导出列表
        deliverData() {
            if (this.form.ids.length == 0) {
                this.$message.warning('请勾选导出的数据')
            } else {
                this.$api.platformAccountExport(this.form).then(res => {
                    if (res.code == 0) {
                        this.downloadlink(res.data)
                        this.$message({
                            type: 'success',
                            message: '导出成功!'
                        })

                    }
                })
            }
        },
        // 批量转移
        transferData() {
            if (this.form.ids.length == 0) {
                this.$message.warning('请勾选转移的数据')
            } else {
                this.selectIds = []
                this.$refs.orgPicker.show([],'user','transferUser')
            }
        },        
        // 更多操作
        command(command, val) {
            if (command == 'transfer') {
                this.selectIds = []
                this.selectIds.push(val.id)
                this.$refs.orgPicker.show([],'user','transferUser')
            } else if (command == 'cancel') {
                this.selectIds = []
                this.selectIds.push(val.id)
                this.$refs.popCancel.show()
            }else if (command == 'revoke') {
                this.selectIds = []
                this.selectIds.push(val.id)
                this.$refs.popRevoke.show()
            }else if (command == 'delete') {
                this.selectIds = []
                this.selectIds.push(val.id)
                this.$refs.popDelete.show()
            } else if (command == 'remark') {
                this.selectIds = []
                this.selectIds.push(val.id)
                this.$refs.popRemark.show(val.remarks)
            } 
        },
        // 备注
        setRemark(data){
            const  params = {
                id: this.selectIds[0],
                remarks:data.remarks
            }
            console.log('>>',params)
             this.$api.platformAccountRemark(params).then(res => {
                if (res.code == 0) {
                    this.fetchData()
                }
            })
        },
        getStatus(form) {
            this.$api.platformAccountStatus(form).then(res => {
                if (res.code == 0) {
                    this.platformAccountData = res.data || [];
                }
            })
        },
        //所属平台
        getShop(){
            this.$api.getShopPlatform().then((res) => {
                if(res.code == 0){
                    this.shops = res.data
                }
            })
        },
        changeData(val) {
            this.createdTime = val

        },
        changeUpdatedData(val) {
            this.updatedTime = val
        },
        fetchData(type) {
            if (type == 'reset') {
                this.form = {
                    pageNo: 1,
                    pageSize: 10,
                    platformKey: '',
                    ownerUserName: '',
                    orgId1:[],
                    ownerOrgPath: '',
                    usingStatus: '',
                    regType: '',
                    ownerUserStatus: '',
                    status: '',
                    actStatus: '',
                    lostId:'',
                    officeStatus:'',
                    createdTimeStart: '',
                    createdTimeEnd: '',
                    updatedTimeStart: '',
                    updatedTimeEnd: '',
                    ids: []

                }
                this.createdTime = []
                this.updatedTime = []
                this.page.pageNo = 1
            } else {
                this.setTimeRange('createdTime', 'createdTimeStart', 'createdTimeEnd');
                this.setTimeRange('updatedTime', 'updatedTimeStart', 'updatedTimeEnd');
            }
            this.form.pageNo = this.page.pageNo
            this.form.pageSize = this.page.pageSize
            if (type == 'search') {
                this.form.pageNo = 1
                this.page.pageNo = 1
            }
            this.form.ids = []
            this.loading = true
            this.$api.platformAccountList(this.form).then((res) => {
                console.log(res)
                if (res.code == 0) {
                    let list = res.data.list || []
                    this.totalNum = res.data.totalNum
                    //获取ID列表查询权限
                    if(list.length > 0){
                        let listIds = []
                        list.forEach(item => {
                            listIds.push(item.id)
                        });
                        // console.log(listIds,'查看有没有权限');
                        this.$api.platformCheckPermission({propertyIds:listIds}).then(res => {
                            if (res.code == 0) {
                                this.perList = (res.data && res.data.accountPermissionMap) || {}
                                list.forEach(item => {
                                    item.permission = this.perList[item.id] || {}
                                    item.hasMore = this.checkHasMore(item.permission)
                                })
                                this.list = list
                            }
                        })
                    }else{
                        this.list = []
                        this.totalNum = 0
                    }
                } else {
                    this.$message.error(res.message)
                }
            }).finally(() => {
                this.loading = false
            })
            this.getStatus(this.form);
        },
        onMultipleSelection(val) {
            // if (val.length == this.page.pageSize) {
            //     this.form.allFlag = 1
            // }
            if (val) {
                this.form.ids = val.map((item) => {
                    return item.id
                })
            }

        },
        reset() {
           this.$refs.form.resetFields()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.fetchData()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e
            this.fetchData()
        },
        lookDetail(val) {
            this.$router.push({ path: 'detail', query: { id: val.id } })
        },
        add() {
            this.$router.push({ path: 'add' })
        },
        handleSelectOrgId(e) {
            console.log(e)
            this.form.ownerOrgPath = e[e.length - 1]
        },
        // 部门选择列表
        department() {
            const postData = {
                    request: {
                        orgName: "",
                        orgType: "",
                    },
                    version: "",
                }
            this.$api.orgSelect(postData).then((res) => {
                if (res.code == 0) {
                    this.options = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 设置时间范围
        setTimeRange(sourceField, startField, endField) {
            const timeRange = this[sourceField];
            this.form[startField] = timeRange?.length > 0 ? timeRange[0] : '';
            this.form[endField] = timeRange?.length > 0 ? timeRange[1] : '';
        },
        // 根据权限对象设置是否有更多操作
        checkHasMore(obj) {
          return Object.values(obj).some(value => value === 1)
        },
    }

}
</script>

<style lang="scss" src="@/pages/assetManagement/common/style/list.scss" scoped />
<style lang="scss">
.lb-table {
    // 主 子账号
    .account-con{
        display: inline-flex;
        align-items: center;
    }
    .icon{
        width: 18px;
        height: 18px;
        display: inline-block;
        border-radius: 2px;
        box-sizing: border-box;
        border: 1px solid #00b498;
        font-size: 11px;
        line-height: 15px;
        color: #00b498;
        text-align: center;
        overflow: hidden;
        margin: 0 5px;
        transform:scale(.9);
        flex-shrink: 0;

    }
    // 手机状态 1待转移 2已转移 3已注销
    .icon-status {
        font-size: 14px;
        line-height: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        width: 50px;
        height: 24px;
        margin-left: 5px;
    }
    .icon-status-1 {
        color: #939696;
        background-color: #F7F7F7;
    }
    .icon-status-2 {
        color: #00B498;
        background-color: #E4F7F4;
    }
    .icon-status-3 {
        color: #E23C58;
        background-color: #FCE9EC;
    }
    // 审批状态 1无审批 2审批中 3审批通过 4驳回
    .icon-act-status {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-top: 9px;
        margin-right: 4px;
    }
    .icon-act-status-1 {
        border: 1px solid #C5C9C9;
        box-sizing: border-box;
    }
    .icon-act-status-2 {
        background: #F5C401;
    }
    .icon-act-status-3 {
        background: #00B498;
    }
    .icon-act-status-4 {
        background: #E23C58;
    }
    .icon-act-status-5 {
        background: #C5C9C9;
    }
}
</style>